const BPMNameSelect = props => {
  let selectedName = ""
  let arrayName = [
    "Larghissimo",
    "Grave",
    "Lento",
    "Largo",
    "Larghetto",
    "Adagio",
    "Adagietto",
    "Andante Moderato",
    "Andante",
    "Andantino",
    "Marcia Moderato",
    "Moderato",
    "Allegretto",
    "Allegro",
    "Vivace",
    "Vivacissimo",
    "Allegrissimo",
    "Presto",
    "Prestissimo"
  ]

  switch (true) {
    case props < 20:
      selectedName = arrayName[0]
      break
    case props < 40:
      selectedName = arrayName[1]
      break
    case props < 45:
      selectedName = arrayName[2]
      break
    case props < 50:
      selectedName = arrayName[3]
      break
    case props < 55:
      selectedName = arrayName[4]
      break
    case props < 65:
      selectedName = arrayName[5]
      break
    case props < 69:
      selectedName = arrayName[6]
      break
    case props < 73:
      selectedName = arrayName[7]
      break
    case props < 78:
      selectedName = arrayName[8]
      break
    case props < 83:
      selectedName = arrayName[9]
      break
    case props < 86:
      selectedName = arrayName[10]
      break
    case props < 98:
      selectedName = arrayName[11]
      break
    case props < 110:
      selectedName = arrayName[12]
      break
    case props < 132:
      selectedName = arrayName[13]
      break
    case props < 140:
      selectedName = arrayName[14]
      break
    case props < 150:
      selectedName = arrayName[15]
      break
    case props < 168:
      selectedName = arrayName[16]
      break
    case props < 178:
      selectedName = arrayName[17]
      break
    case props >= 178:
      selectedName = arrayName[18]
      break
    default:
      break
  }

  return selectedName
}

export default BPMNameSelect
